module.exports = __webpack_public_path__ + "img/home__3D——zh.29aea4fa.png";